import { FC, useEffect, useState } from 'react';
import moment from 'moment';
import { ChipModel } from 'shared/components/filters/Chip';
import FilterChipsBar from 'shared/components/filters/FilterChipsBar';
import {
  ContingencyReason,
  ContingencyType,
  contingencyService
} from 'app/viaje/viajeTraslado/coordinar/services/contingencyService';
import { ContingencyFilters } from '../hooks/useContingencies';

const formatDate = (value?: string) => {
  if (!value) return '';
  const m = moment(value);
  return m.isValid() ? m.format('DD/MM/YYYY HH:mm') : value;
};

interface Props {
  filters: ContingencyFilters;
  onFiltersChange: (filters: ContingencyFilters) => void;
}

const ContingenciesChipsBar: FC<Props> = ({ filters, onFiltersChange }) => {
  const service = contingencyService();
  const [reasonsMap, setReasonsMap] = useState<Record<number, string>>({});
  const [typesMap, setTypesMap] = useState<Record<number, string>>({});

  useEffect(() => {
    service
      .getContingencyReasons()
      .then((rows: ContingencyReason[]) => {
        setReasonsMap(
          rows.reduce((acc, r) => {
            acc[r.id] = r.label;
            return acc;
          }, {} as Record<number, string>)
        );
      })
      .catch(() => {});
    service
      .getContingencyTypes()
      .then((rows: ContingencyType[]) => {
        setTypesMap(
          rows.reduce((acc, t) => {
            acc[t.id] = t.label;
            return acc;
          }, {} as Record<number, string>)
        );
      })
      .catch(() => {});
  }, []);

  const chips: ChipModel[] = [];

  if (filters.contingency_reason_id !== undefined) {
    chips.push({
      label: 'Razón:',
      value:
        reasonsMap[filters.contingency_reason_id] ??
        String(filters.contingency_reason_id),
      onDelete: () => {
        const { contingency_reason_id, ...rest } = filters;
        onFiltersChange(rest);
      }
    });
  }

  if (filters.contingency_type_id !== undefined) {
    chips.push({
      label: 'Tipo:',
      value:
        typesMap[filters.contingency_type_id] ??
        String(filters.contingency_type_id),
      onDelete: () => {
        const { contingency_type_id, ...rest } = filters;
        onFiltersChange(rest);
      }
    });
  }

  if (filters.polygon_zone_id !== undefined) {
    chips.push({
      label: 'Zona:',
      value: String(filters.polygon_zone_id),
      onDelete: () => {
        const { polygon_zone_id, ...rest } = filters;
        onFiltersChange(rest);
      }
    });
  }

  if (filters.applied_by_user_id !== undefined) {
    chips.push({
      label: 'Usuario:',
      value: String(filters.applied_by_user_id),
      onDelete: () => {
        const { applied_by_user_id, ...rest } = filters;
        onFiltersChange(rest);
      }
    });
  }

  if (filters.applied_at) {
    chips.push({
      label: 'Aplicada:',
      value: formatDate(filters.applied_at),
      onDelete: () => {
        const { applied_at, ...rest } = filters;
        onFiltersChange(rest);
      }
    });
  }

  if (filters.finished_at) {
    chips.push({
      label: 'Finaliza:',
      value: formatDate(filters.finished_at),
      onDelete: () => {
        const { finished_at, ...rest } = filters;
        onFiltersChange(rest);
      }
    });
  }

  if (filters.observation) {
    chips.push({
      label: 'Observación:',
      value: filters.observation,
      onDelete: () => {
        const { observation, ...rest } = filters;
        onFiltersChange(rest);
      }
    });
  }

  return <FilterChipsBar chips={chips} />;
};

export default ContingenciesChipsBar;
